import { useEffect } from 'react';

function InspiniaAux() {
  useEffect(() => {
    const script = document.getElementById('inspinia-helper-script');
    if (script) script.parentElement.removeChild(script);

    const newScript = document.createElement('script');
    newScript.innerHTML = `
            $('.navbar-minimalize').on('click', function (event) {
                event.preventDefault();
                $("body").toggleClass("mini-navbar");
                SmoothlyMenu();
            });
    `;
    document.body.append(newScript);
  }, []);

  return null;
}

export default InspiniaAux;
